import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { registrarTap } from "../api";

const SugerenciaCard = ({ comercio, estaLogueado, handleToggleSeguir }) => {
  const navigate = useNavigate();
  const seguidoBool = !!comercio.seguido;

  const irADetalle = () => {
    const id_perfil = localStorage.getItem("id_perfil");
    const id_sucursal = comercio.id_sucursal;

    registrarTap(id_sucursal, "home_vip", id_perfil);

    setTimeout(() => {
      navigate(`/comercio/${comercio.id}/${id_sucursal}`);
    }, 180);
  };

  const estadoHorario = comercio.estadoHorario || {};
  const esOnline = Number(comercio.online) === 1;
  const estadoTexto = esOnline
    ? "Solo en línea"
    : estadoHorario.abierto
      ? estadoHorario.texto || "Abierto ahora"
      : estadoHorario.texto || "Cerrado";
  const detalleTexto = esOnline
    ? "Servicio digital"
    : estadoHorario.detalle || (comercio.distancia && comercio.distancia !== "Acceso a la ubicación requerido."
      ? comercio.distancia
      : "Acceso a la ubicación requerido.");

  return (
    <article
      className="suggestion-card"
      onClick={irADetalle}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          irADetalle();
        }
      }}
    >
      <div className="suggestion-card__media">
        <img
          src={comercio.portada || comercio.logo || "/assets/images/default.png"}
          alt={comercio.nombre}
          loading="lazy"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = comercio.logo || "/assets/images/default.png";
          }}
        />
        <div className="suggestion-card__distance">{comercio.distancia || "Acceso a la ubicación requerido."}</div>
      </div>

      <div className="suggestion-card__body">
        <div className="suggestion-card__brand">
          <img
            className="suggestion-card__logo"
            src={comercio.logo || "/assets/images/default.png"}
            alt={comercio.nombre}
            loading="lazy"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/assets/images/default.png";
            }}
          />
          <div className="suggestion-card__text">
            <h4>{comercio.nombre}</h4>
            <p className={estadoHorario.abierto || esOnline ? "is-open" : "is-closed"}>
              {estadoTexto}
            </p>
            <span>{detalleTexto}</span>
          </div>
        </div>

        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            handleToggleSeguir(comercio.id);
          }}
          className={`suggestion-card__follow ${estaLogueado && seguidoBool ? "is-followed" : ""}`}
        >
          {estaLogueado && seguidoBool ? "Seguido" : "Seguir"}
        </button>
      </div>
    </article>
  );
};

const SugerenciasCarousel = ({ comercios = [], estaLogueado, handleToggleSeguir }) => {
  const railRef = useRef(null);
  const pauseUntilRef = useRef(0);

  useEffect(() => {
    const rail = railRef.current;
    if (!rail || comercios.length <= 1) return undefined;

    let intervalId = null;
    const startDelay = window.setTimeout(() => {
      intervalId = window.setInterval(() => {
        if (Date.now() < pauseUntilRef.current) return;
        const maxScrollLeft = rail.scrollWidth - rail.clientWidth;
        const current = rail.scrollLeft;
        const firstCard = rail.querySelector(".suggestion-card");
        if (!firstCard) return;

        const gap = parseFloat(getComputedStyle(rail).gap || "0") || 0;
        const step = firstCard.getBoundingClientRect().width + gap;
        const next = current + step;

        if (next >= maxScrollLeft - 4) {
          rail.scrollTo({ left: 0, behavior: "smooth" });
        } else {
          rail.scrollBy({ left: step, behavior: "smooth" });
        }
      }, 5600);
    }, 1500);

    return () => {
      window.clearTimeout(startDelay);
      if (intervalId) window.clearInterval(intervalId);
    };
  }, [comercios.length]);

  if (!comercios || comercios.length === 0) return null;

  return (
    <section className="suggestions-container suggestions-container--carousel">
      <div className="suggestions-header">
        <h3>Sugerencias para ti</h3>
      </div>
      <div
        className="suggestions-rail"
        ref={railRef}
        onTouchStart={() => { pauseUntilRef.current = Date.now() + 8000; }}
        onMouseDown={() => { pauseUntilRef.current = Date.now() + 8000; }}
        onWheel={() => { pauseUntilRef.current = Date.now() + 8000; }}
        onScroll={() => { pauseUntilRef.current = Date.now() + 8000; }}
      >
        {comercios.map((comercio) => (
          <SugerenciaCard
            key={comercio.id}
            comercio={comercio}
            estaLogueado={estaLogueado}
            handleToggleSeguir={handleToggleSeguir}
          />
        ))}
      </div>
    </section>
  );
};

export default SugerenciasCarousel;
